import type { ReactNode } from "react";

import { BwLogoSymbol } from "@/components/ui/icons";

/** The signed-out presale shell — the onboarding header reduced to the logo. */
export function PresalePublicShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-svh flex-col">
      <div className="sticky top-0 z-10 shrink-0 bg-bg-light-blur backdrop-blur-2xl">
        <header className="flex h-16 items-center px-4 sm:px-6">
          <BwLogoSymbol className="size-8 shrink-0 text-text-primary" />
        </header>
      </div>
      <main className="flex min-h-0 flex-1 flex-col overflow-hidden bg-bg-light">
        {children}
      </main>
    </div>
  );
}
